export default {
  popper: {
    display: 'none'
  }
};
